const pnl = h => (h.currentVal||0) - (h.invested||0);
const pnlRatio = h => h.invested ? ((h.currentVal||0)-h.invested)/h.invested : 0;
const pnlPct = (h, fallback="0.0") => h.invested ? (pnlRatio(h)*100).toFixed(1) : fallback;
const topCats = cats => cats.filter(c=>!c.parent);
const subCats = (cats,pid) => cats.filter(c=>c.parent===pid);

/* ══ BILINGUAL DISPLAY HELPERS ═══════════════════════════════
   Single source of truth for "show Arabic if available and viewer
   is RTL, otherwise show the original" — the pattern was duplicated
   ~40x across the codebase with subtle inconsistencies. Use these
   helpers everywhere so future audits are trivial. */
const localText = (item, lang, field="name", fallback="—") => {
  if (!item) return fallback;
  const ar = item[field+"Ar"];
  const en = item[field];
  if (lang === "ar" && ar && ar.trim()) return ar;
  return en || ar || fallback;
};
const localName = (item, lang) => localText(item, lang, "name", "");
const localDesc = (item, lang) => localText(item, lang, "description", "");
const localTitle = (item, lang) => localText(item, lang, "title", "");
const localLabel = (item, lang) => localText(item, lang, "label", "");
const localGroup = (item, lang) => localText(item, lang, "group", "");

/* ══ ENTITY LOOKUPS (now localised) ═════════════════════════
   catName/locName/userName were always returning .name — now they
   resolve the viewer language when callers pass lang as a 3rd arg.
   The 2-arg signature stays backward-compatible. */
const catName = (cats, id, lang) => {
  const c = cats.find(c=>c.id===id);
  return c ? localName(c, lang) || "—" : "—";
};
const userName = (users, id, lang) => {
  const u = users.find(u=>u.id===id);
  return u ? localName(u, lang) || id : id;
};
const locName = (locs, id, lang) => {
  const l = locs.find(l=>l.id===id);
  return l ? localName(l, lang) || "—" : "—";
};


/* Module subtitle resolver. SuperAdmin can override the default subtitle
   per module (state.moduleSubtitles[key]). The override is stored as a
   single string. If the viewer is on Arabic but the override has no Arabic
   characters, the override would otherwise leak English into an Arabic
   page — fall back to the dictionary in that case. dictKey is the key in
   translations.js (e.g. "subtitle_Income"). */
const AR_RE = /[؀-ۿ]/;
const moduleSubtitle = (state, moduleKey, t, lang) => {
  const override = state?.moduleSubtitles?.[moduleKey];
  const dictText = t?.[`subtitle_${moduleKey}`] || "";
  if (!override) return dictText;
  if (lang === "ar" && !AR_RE.test(override)) return dictText;
  return override;
};

export { pnl, pnlRatio, pnlPct, topCats, subCats, catName, userName, locName, localText, localName, localDesc, localTitle, localLabel, localGroup, moduleSubtitle };
